var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevKvantKg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 10.8518L17.9277 9.41639C18.6427 8.34494 18.7083 6.97518 18.0986 5.84083C17.4884 4.70531 16.3063 4 15.0132 4H9.98685C8.69375 4 7.51159 4.70531 6.90143 5.8407C6.29167 6.97518 6.35716 8.34494 7.07214 9.41652L7.9974 10.8518C6.72292 12.0706 6 13.7487 6 15.5215C6 17.6947 7.08763 19.7117 8.90938 20.9169L9.03516 21H15.9648L16.0906 20.9169C17.9124 19.7117 19 17.6947 19 15.5215C19 13.7487 18.2771 12.0706 17.0026 10.8518V10.8518ZM15.4292 7.76259L14.4151 9.3326C13.7971 9.14285 13.1548 9.04688 12.5 9.04688C11.8452 9.04688 11.2029 9.14285 10.5849 9.3326L9.57526 7.76933L9.57083 7.76259C9.43372 7.55779 9.48203 7.37103 9.54622 7.25105C9.61068 7.13121 9.73945 6.98828 9.98685 6.98828H15.0132C15.2605 6.98828 15.3893 7.13121 15.4534 7.25053C15.518 7.37103 15.5663 7.55779 15.4292 7.76259V7.76259Z",
    fill: "#333B69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevKvantKg);
export default __webpack_public_path__ + "static/media/lev-kvant-kg.782d09c5.svg";
export { ForwardRef as ReactComponent };